import { PropsWithChildren } from 'react'

export const OverlayComponent = (props: PropsWithChildren & { display: boolean; zIndex?: number }) => {
  const style: any = {}
  if (props.display) {
    style.display = 'block'
  }
  if (props.zIndex) {
    style.zIndex = props.zIndex
  }
  return (
    <div className='overlay' style={style}>
      {props.children}
    </div>
  )
}
